/**
 * 契约边界工具 — 只服务于「后端线格式 ↔ 前端内部表示」的窄转换，业务代码不该依赖它。
 *
 * 背景（§6.2 字段表；具文见 v1.7 锚 `shared/_anchors/DEV-DOC-BACKEND-bpo-marketing-delivery__a9bc03ae.md` L439 节题／L463 `userId | long | req`）：主键类字段后端为 `long`，而前端内部模型统一用 `string` ｜CITATION-PENDING（回补条件＝ADMIN 承接件把 §6.0／§6.2 具文同步进 shared ⇒ 本处出处由项目面锚改指承接件；产品 seq=107 §一）
 * 承载 id（便于 mock 的 `P-01` / `ord-*` 之类的可读主键共存）。写请求回传时必须还原为
 * 数值，否则 `System.Text.Json` 默认不接受字符串→long，会得到 400 `VALIDATION_FAILED`。
 */

/** 前端 id → 后端 long；非纯数字（mock 可读主键）原样透传，由桩/网关消化 */
export function toApiId(id: string | number): string | number {
  const raw = String(id).trim();
  if (/^\d+$/.test(raw)) {
    const n = Number(raw);
    // 超过 JS 安全整数范围时保持字符串：宁可让后端报错，也不静默丢精度
    return Number.isSafeInteger(n) ? n : raw;
  }
  return raw;
}

/** 批量 id → 后端 long[] */
export function toApiIds(ids: Array<string | number>): Array<string | number> {
  return ids.map(toApiId);
}

/** 响应里的可空数值（§6.0-③：null 字段仍会写出，须判 null 而非判键缺失） */
export function numOf(value: unknown, fallback = 0): number {
  const n = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(n) ? n : fallback;
}

/** 0–1 小数 → 百分比整数（§6.2-2 `recent7dCompletionRate` 要求前端自行 ×100 加 %） */
export function toPercent(rate: unknown): string {
  const n = numOf(rate, 0);
  return `${Math.round(n <= 1 ? n * 100 : n)}%`;
}
